import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataAssistantWF: localStorage.getItem("dataAssistantWF")
    ? JSON.parse(localStorage.getItem("dataAssistantWF"))
    : [],
  newAssistantWF: null,
  activeAssistantWF: localStorage.getItem("activeAssistantWF")
    ? JSON.parse(localStorage.getItem("activeAssistantWF"))
    : null,
  updateAssistantWF: false,
  updateAssistantWFData: {},
};

const assistantWFSlice = createSlice({
  name: "assistantWF",
  initialState,
  reducers: {
    setDataAssistantWF(state, action) {
      state.dataAssistantWF = action.payload;
    },
    setNewAssistantWF(state, action) {
      state.newAssistantWF = action.payload;
    },
    setActiveAssistantWF(state, action) {
      state.activeAssistantWF = action.payload;
    },
    setUpdateAssistantWF(state, action) {
      state.updateAssistantWF = action.payload;
    },
    setUpdateAssistantWFData(state, action) {
      state.updateAssistantWFData = action.payload;
    },
  },
});

export const {
  setDataAssistantWF,
  setNewAssistantWF,
  setActiveAssistantWF,
  setUpdateAssistantWF,
  setUpdateAssistantWFData,
} = assistantWFSlice.actions;

export default assistantWFSlice.reducer;
